<template>
    <div class="webcast-help">
      <!-- 页面标题 -->
      <div v-wechat-title="'蜗蜗直播 亏掉底裤 -《最强蜗牛》'"></div>

      <!-- 助力按钮 -->
      <div class="help-btn" @click="onHelp()"></div>

      <!-- 弹窗 -->
      <div :class="`popupWrap ${ratio}`">
        <!-- 助力成功 -->
        <div :class="`popup success ${popup.success}`" @click.self="popup.success = false">
          <div class="popup-main">
            <div class="confirm-btn" @click="popup.success = false"></div>
          </div>
        </div>

        <!-- 助力失败 -->
        <div :class="`popup fail ${popup.fail} type-${type}`" @click.self="popup.fail = false">
          <div class="popup-main">
            <div class="join-btn" @click="goLink('https://h5.qingcigame.com/snail/webcast/enter{timestamp}', '最强蜗牛_三只蜗直播间_助力页_点击参与活动按钮')"></div>
            <div class="download-btn" @click="goLink('https://snail.qingcigame.com/', '最强蜗牛_三只蜗直播间_助力页_点击下载游戏按钮')"></div>
          </div>
        </div>
      </div>
    </div>
  </template>
  
  <script>
  import Vue from "vue"
  import { Toast } from 'mint-ui'
  import { mapState, mapMutations, mapActions } from 'vuex'
  import { getTimeStamp, buriedLogger, analysisParams } from '@/utils/utils'
  import { onHelpInitAPI, onHelpAPI } from '../api'
  
  export default {
    name: 'webcast-help',
    data() {
      return {
        ratio: '', // 屏幕比例
        type: 1, // 弹窗类型，1已助力，2助力已达上限
        popup: {
          success: false,
          fail: false
        },
      }
    },
    computed: { ...mapState(['userInfo', 'activeInfo', 'isShowLogin', 'isShowOs'])},
    created () {
      if (!global.consoleSwitch) console.log = () => {}
  
      // 自适应
      window.addEventListener('pageshow', this.resize)
      window.addEventListener('resize', this.resize)
  
      // 清空store上的用户数据
      this.setInitActiveInfo()
      this.setInitUserInfo()
  
      // 埋点
      const bl = buriedLogger('snail', '最强蜗牛_三只蜗直播间')
      this.logger = bl
      setTimeout(() => {
        this.logger.sum('最强蜗牛_三只蜗直播间_访问助力页')
      }, 200)
    },
    mounted () {
      this.onInit()
    },
    methods: {
      // 自适应
      resize () {
        if (window.innerWidth >= 540) document.documentElement.style.fontSize = '54px'
        if (this.timer1) clearTimeout(this.timer1)
        this.timer1 = setTimeout(() => {
          // 兼容宽屏
          const ratio = window.innerWidth / window.innerHeight
          if (ratio > 320 / 510) {
            this.ratio = 'ratio1'
          } else if (ratio > 320 / 570) {
            this.ratio = 'ratio2'
          } else {
            this.ratio = ''
          }
        }, 320)
      },
      // 初始化
      onInit () {
        onHelpInitAPI({
          friend_id: analysisParams(location.href).friend_id
        }).then(response => {
          if (Number(response.code) == 302) {
            // 未授权
            var ua = navigator.userAgent.toLowerCase()
            if (ua.match(/MicroMessenger/i) == "micromessenger") {
              // 微信环境下
              window.location.href = `${response.data["wechat_url"]}?callback=${encodeURI(window.location.href)}`
              return
            } else {
              // QQ环境下
              window.location.href = `${response.data["qq_url"]}?callback=${encodeURI(window.location.href)}`
              return
            }
          }
          Number(response.code) !== 200 && this.onToast(response.message)
        })
      },
      // 助力
      onHelp () {
        onHelpAPI({
          friend_id: analysisParams(location.href).friend_id
        }).then(response => {
          if (Number(response.code) === 200) {
            this.showPopup('success')
            return
          }
          if (Number(response.code) === 405) {
            this.type = 2
            this.showPopup('fail')
          }
          if (Number(response.code) === 406) {
            this.type = 1
            this.showPopup('fail')
          }
          Number(response.code) !== 401 && this.onToast(response.message)
        })
      },
      // 打开弹窗
      showPopup (name) {
        switch (name) {
          case 'success':
            this.popup.success = true
            this.logger.sum('最强蜗牛_三只蜗直播间_助力页_助力成功')
            break
          case 'fail':
            this.popup.fail = true
            this.type === 1 ? this.logger.sum('最强蜗牛_三只蜗直播间_助力页_打开已助力弹窗') : this.logger.sum('最强蜗牛_三只蜗直播间_助力页_打开助力已满弹窗')
            break
        }
      },
      // TAG: 其他简易封装的方法
      onToast (config) {
        const curConfig = {
          duration: 1000,
          className: 'toasts'
        };
        if (!config) {
          console.error('缺少config参数');
          return false;
        }
        if (typeof config === 'string') {
          curConfig.message = config;
        }
        Toast(curConfig);
      },
      // 前往重定向
      goLink (url, loggerName) {
        if (url === '') return
        this.logger.sum(loggerName)
        setTimeout(() => { window.open(url) }, 200)
      },
      ...mapMutations(["setUserInfo", 'changeLoginPopup', 'changeOsPopup', 'setInitActiveInfo', 'setInitUserInfo']),
      ...mapActions(['onInitDataCallback', "setShare"])
    }
  };
  </script>
  
  <style lang="less">
  @import "./index.less";
  </style>


// WEBPACK FOOTER //
// src/pages/snail/webcast/help/index.vue